import { Component, EventEmitter, Input, Output} from '@angular/core';
import { Router } from '@angular/router';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { NexusComponent } from 'app/core/components/nexus/nexus.component';
import { PaymentMethodModel } from 'app/models/payment-method.model';
import { PaymentMethodService } from 'app/services/payment-method.service';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'module-payment-method-primary',
    templateUrl: './payment-method-primary.component.html',
    styleUrls: ['./payment-method-primary.component.css'],
    standalone: false
})
export class PaymentMethodPrimaryComponent extends NexusComponent  {
  @Input() public payment_methods_model: Array<PaymentMethodModel>;
  @Input() public payment_method_model: PaymentMethodModel = new PaymentMethodModel();
  @Output() public primaryPaymentMethodSelected: EventEmitter<PaymentMethodModel> = new EventEmitter<PaymentMethodModel>();

  public get payment_methods_list(): Array<PaymentMethodModel> {
    if (!this.payment_methods_model?.length)
      {return [];}

    return [this.payment_method_model].concat(this.payment_methods_model.filter(pm => pm.id !== this.payment_method_model.id).sort((a,b) => a.created_date.toISOString() < b.created_date.toISOString() ? -1 : 1));
  }

  public success_message:string;

  public faCheck = faCheck;

  constructor(private router: Router, private payment_method_service: PaymentMethodService) {
     super();
   }

  setDefault(payment_method: PaymentMethodModel) {
    this.StartSpinner();
    this.payment_method_service.SetDefaultPaymentMethod(payment_method.id).subscribe(
      data => {
        this.payment_methods_model = data;
        this.success_message = `We've set ****${(payment_method.account_type === 'Checking' ? payment_method.ch_number_mask : payment_method.cc_number_mask)?.slice(-4)} as your new primary payment method!`;
        this.payment_methods_model.map(pm => pm.default_account = payment_method.id === pm.id);
        this.payment_method_model.default_account = payment_method.id === this.payment_method_model.id;

        this.primaryPaymentMethodSelected.emit(payment_method);

        if (this.payment_methods_model?.length > 1) {
          // reset the message after thirty seconds.  This will keep things consistent with the delete component... hopefully...
          setTimeout(() => this.success_message = '', 3000);
        }

        this.StopSpinner();
      },
      err => {
        this.StopSpinner();
      });
    return false;
  }

}
